import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { IProduct } from "./../../../shared/models/products/product";
import { IPurchase, Purchase } from "./../../../shared/models/purchase";
import { PurchaseStateService } from "./../../../shared/services/purchase-state.service";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-product-list",
  templateUrl: "./product-list.component.html",
  host: { class: "cart" },
})
export class ProductListComponent implements OnInit, OnDestroy {
  purchase: IPurchase;

  @Input() showRemove: boolean = false;
  @Input() showConfirmation: boolean = false;
  @Input() navigateOnEmpty: boolean = true;
  @Input() customPurchase: Purchase;
  private destroy$ = new Subject<void>();

  constructor(
    private purchaseState: PurchaseStateService,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.showConfirmation === false && !this.customPurchase) {
      this.purchaseState.purchase$
        .pipe(takeUntil(this.destroy$))
        .subscribe((p) => (this.purchase = p));
      return;
    }
    this.purchase = this.customPurchase;
  }

  onRemove(product: IProduct) {
    if (!this.showRemove) return;
    this.purchaseState.removeProduct(product);
    if (this.purchaseState.isEmpty && this.navigateOnEmpty) {
      this.router.navigate([""]);
    }
  }

  onPrint() {
    window.print();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
